import { useTheme } from '@mui/material';

export const UserIdentityIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none">
            <path
                fill={primaryStroke}
                d="M3 6.486c0-1.655 1.345-3 3-3h3.75c.412 0 .75.338.75.75 0 .413-.338.75-.75.75H6c-.83 0-1.5.67-1.5 1.5v3.75c0 .413-.338.75-.75.75a.752.752 0 0 1-.75-.75v-3.75Zm16.5-2.25c0-.412.337-.75.75-.75H24c1.655 0 3 1.345 3 3v3.75c0 .413-.337.75-.75.75a.752.752 0 0 1-.75-.75v-3.75c0-.83-.67-1.5-1.5-1.5h-3.75a.752.752 0 0 1-.75-.75ZM3.75 19.986c.412 0 .75.338.75.75v3.75c0 .83.67 1.5 1.5 1.5h3.75c.412 0 .75.338.75.75 0 .413-.338.75-.75.75H6c-1.655 0-3-1.345-3-3v-3.75c0-.412.337-.75.75-.75Zm22.5 0c.413 0 .75.338.75.75v3.75c0 1.655-1.345 3-3 3h-3.75a.752.752 0 0 1-.75-.75c0-.412.337-.75.75-.75H24c.83 0 1.5-.67 1.5-1.5v-3.75c0-.412.337-.75.75-.75ZM9 21.486c0-2.484 2.016-4.5 4.5-4.5h3c2.484 0 4.5 2.016 4.5 4.5v.75c0 .413-.337.75-.75.75a.752.752 0 0 1-.75-.75v-.75c0-1.655-1.345-3-3-3h-3c-1.655 0-3 1.345-3 3v.75c0 .413-.338.75-.75.75a.752.752 0 0 1-.75-.75v-.75Zm7.875-10.125a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0Zm-5.25 0a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0Z"
            />
        </svg>
    );
};
